module.exports = __webpack_public_path__ + "img/journal-text.e7d36eaa.svg";